import { PAYMENT_COMPARISON_TOGGLE_CHART_DATA_TABLE } from './constants'

export const paymentComparisonToggleChartDataTable = (module, block, id, showChartDataTable) => ({
    type: PAYMENT_COMPARISON_TOGGLE_CHART_DATA_TABLE,
    data: {
        module,
        block,
        id,
        showChartDataTable,
    },
})
